/**
 * Badge mapping for classic campaigns — must stay aligned with list `tagCell`
 * (`Content.jsx` / campaigns widget `getInfoForTag`).
 *
 * @param {object} params
 * @param {number|string} [params.statusId]
 * @param {string} [params.statusDescription]
 * @param {number|string} [params.percentageCompleted]
 * @returns {{ type: string, value: string }}
 */
export function getCampaignStatusTagInfo({
    statusId,
    statusDescription = '',
    percentageCompleted,
}) {
    let type = '';
    const id = Number(statusId);

    if (id === 1) type = 'pending';
    else if (id === 2) type = 'ongoing';
    else if (id === 4) {
        if (percentageCompleted === 100) type = 'success';
        else type = 'error';
    } else if (id === 3) type = 'info';

    return {
        value: statusDescription,
        type,
    };
}

/** Maps tag-cell type to @Sage/hoi-poi-ui Badge `type` (pending → default). */
export function mapCampaignTagTypeToBadgeType(tagType) {
    if (tagType === 'pending') return 'default';
    return tagType || 'default';
}

/**
 * @param {object} params
 * @param {number|string} params.statusId
 * @param {string} [params.text]
 * @param {string} [params.statusDescription]
 * @param {number|string} [params.percentageCompleted]
 */
export function getCampaignStatusBadgeType({
    statusId,
    text,
    statusDescription,
    percentageCompleted,
}) {
    const { type } = getCampaignStatusTagInfo({
        statusId,
        statusDescription: text ?? statusDescription ?? '',
        percentageCompleted,
    });
    return mapCampaignTagTypeToBadgeType(type);
}
